// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper[data-v-448ecf91] {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.wrapper .wrapper-item[data-v-448ecf91] {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 15px;
  margin-bottom: 12px;
}
.wrapper .wrapper-item .item-header[data-v-448ecf91] {
  height: 20px;
  align-self: flex-start;
  color: var(--main-body-color);
}
.wrapper .wrapper-item .item-content[data-v-448ecf91] {
  display: flex;
  justify-content: space-between;
}
.wrapper .wrapper-item.examples[data-v-448ecf91] {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 12px;
}
.wrapper .wrapper-item.examples .titles[data-v-448ecf91] {
  display: flex;
  align-items: center;
  height: 68px;
}
.wrapper .wrapper-item.examples .titles .icon-example[data-v-448ecf91] {
  width: 48px;
  height: 48px;
  margin-right: 12px;
  margin-top: -11px;
}
.wrapper .wrapper-item.examples .titles .icon-example img[data-v-448ecf91] {
  height: 100%;
}
.wrapper .wrapper-item.examples .titles .title-example[data-v-448ecf91] {
  display: flex;
  flex-direction: column;
  margin-right: 4px;
  margin-bottom: 12px;
}
.wrapper .wrapper-item.examples .titles .title-example .title[data-v-448ecf91] {
  font-size: var(--titleFontSize);
  filter: contrast(var(--fontContrast));
}
.wrapper .wrapper-item.examples .titles .title-example .subtitle[data-v-448ecf91] {
  font-size: var(--subTitleFontSize);
  filter: contrast(var(--fontContrast));
}
.wrapper .wrapper-item.examples .chat-text-example[data-v-448ecf91] {
  color: var(--font-color);
  background-color: var(--message-right-bgcolor);
  border-radius: 10px;
  padding: 4px;
  align-self: center;
  width: fit-content;
  margin-bottom: 12px;
}
.wrapper .wrapper-item.examples .chat-text-example span[data-v-448ecf91] {
  margin: 0 4px;
  font-size: var(--messageFontSize);
  filter: contrast(var(--fontContrast));
}
.wrapper .wrapper-item.examples .chat-text-example .message-footer[data-v-448ecf91] {
  display: inline-flex;
  position: relative;
  float: right;
  margin: 12px 2px -1px 4px;
  padding-left: 10px;
  font-size: .8em;
  color: var(--chat-time-color);
}
.wrapper .wrapper-item .range-slider[data-v-448ecf91] {
  width: 100%;
  display: flex;
}
.wrapper .wrapper-item .range-slider i[data-v-448ecf91] {
  font-size: 16px;
  margin-top: 10px;
  margin-right: 2px;
  color: #aaa;
}
.wrapper .wrapper-item .range-slider .volume-up[data-v-448ecf91] {
  margin-right: -9px;
}
.wrapper .wrapper-item .range-slider .slider[data-v-448ecf91] {
  width: 100%;
  padding-right: 5px;
}
.wrapper .wrapper-item .range-slider[data-v-448ecf91] range-slider {
  display: inline-block;
  padding: 0 10px;
  height: 5px;
  width: 130px;
}
.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider.disabled {
  opacity: 0.5;
}
.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-inner {
  display: inline-block;
  position: relative;
  height: 100%;
  width: 100%;
}
.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-rail,
.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-fill {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  height: 2px;
  border-radius: 5px;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-rail {
  width: 100%;
  background-color: #e2e2e2;
}
.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-fill {
  background-color: var(--base-blue-color2);
}
.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-knob {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: #aaa;
  -webkit-box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-knob div {
  margin-top: -22px;
  text-align: center;
}
.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-hidden {
  display: none;
}
[data-v-448ecf91] .footer {
  display: flex;
  justify-content: space-between;
}
[data-v-448ecf91] .footer .reset {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: unset !important;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/FontsSettings.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,qCAAqC;AACvC;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;EAC9C,sCAAsC;EACtC,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":[".wrapper[data-v-448ecf91] {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.wrapper .wrapper-item[data-v-448ecf91] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0 15px;\n  margin-bottom: 12px;\n}\n.wrapper .wrapper-item .item-header[data-v-448ecf91] {\n  height: 20px;\n  align-self: flex-start;\n  color: var(--main-body-color);\n}\n.wrapper .wrapper-item .item-content[data-v-448ecf91] {\n  display: flex;\n  justify-content: space-between;\n}\n.wrapper .wrapper-item.examples[data-v-448ecf91] {\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-top: 12px;\n}\n.wrapper .wrapper-item.examples .titles[data-v-448ecf91] {\n  display: flex;\n  align-items: center;\n  height: 68px;\n}\n.wrapper .wrapper-item.examples .titles .icon-example[data-v-448ecf91] {\n  width: 48px;\n  height: 48px;\n  margin-right: 12px;\n  margin-top: -11px;\n}\n.wrapper .wrapper-item.examples .titles .icon-example img[data-v-448ecf91] {\n  height: 100%;\n}\n.wrapper .wrapper-item.examples .titles .title-example[data-v-448ecf91] {\n  display: flex;\n  flex-direction: column;\n  margin-right: 4px;\n  margin-bottom: 12px;\n}\n.wrapper .wrapper-item.examples .titles .title-example .title[data-v-448ecf91] {\n  font-size: var(--titleFontSize);\n  filter: contrast(var(--fontContrast));\n}\n.wrapper .wrapper-item.examples .titles .title-example .subtitle[data-v-448ecf91] {\n  font-size: var(--subTitleFontSize);\n  filter: contrast(var(--fontContrast));\n}\n.wrapper .wrapper-item.examples .chat-text-example[data-v-448ecf91] {\n  color: var(--font-color);\n  background-color: var(--message-right-bgcolor);\n  border-radius: 10px;\n  padding: 4px;\n  align-self: center;\n  width: fit-content;\n  margin-bottom: 12px;\n}\n.wrapper .wrapper-item.examples .chat-text-example span[data-v-448ecf91] {\n  margin: 0 4px;\n  font-size: var(--messageFontSize);\n  filter: contrast(var(--fontContrast));\n}\n.wrapper .wrapper-item.examples .chat-text-example .message-footer[data-v-448ecf91] {\n  display: inline-flex;\n  position: relative;\n  float: right;\n  margin: 12px 2px -1px 4px;\n  padding-left: 10px;\n  font-size: .8em;\n  color: var(--chat-time-color);\n}\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] {\n  width: 100%;\n  display: flex;\n}\n.wrapper .wrapper-item .range-slider i[data-v-448ecf91] {\n  font-size: 16px;\n  margin-top: 10px;\n  margin-right: 2px;\n  color: #aaa;\n}\n.wrapper .wrapper-item .range-slider .volume-up[data-v-448ecf91] {\n  margin-right: -9px;\n}\n.wrapper .wrapper-item .range-slider .slider[data-v-448ecf91] {\n  width: 100%;\n  padding-right: 5px;\n}\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] range-slider {\n  display: inline-block;\n  padding: 0 10px;\n  height: 5px;\n  width: 130px;\n}\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider.disabled {\n  opacity: 0.5;\n}\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-inner {\n  display: inline-block;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-rail,\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-fill {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  height: 2px;\n  border-radius: 5px;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-rail {\n  width: 100%;\n  background-color: #e2e2e2;\n}\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-fill {\n  background-color: var(--base-blue-color2);\n}\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-knob {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background-color: #aaa;\n  -webkit-box-shadow: 1px 1px rgba(0, 0, 0, 0.2);\n  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-knob div {\n  margin-top: -22px;\n  text-align: center;\n}\n.wrapper .wrapper-item .range-slider[data-v-448ecf91] .range-slider-hidden {\n  display: none;\n}\n[data-v-448ecf91] .footer {\n  display: flex;\n  justify-content: space-between;\n}\n[data-v-448ecf91] .footer .reset {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-left: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
